/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Typography, FormControl, Select, MenuItem, Pagination } from "@mui/material";

const PaginationFooter = (props) => {
    
    // const pagination = props?.pagination;
    
    const page = props?.page;
    const pageSize = props?.pageSize;
    const pages = props?.pages;
    // const firstPos = props?.firstPos;
    // const lastPos = props?.lastPos;
    const total = props?.total;
    const handlePageSizeChange = props?.handlePageSizeChange;
    const selectPage = props?.selectPage;
    
    // const rowsMessage = (firstPos && lastPos)?`${firstPos}-${lastPos}`:"";
    // const countMessage = total?` of ${total}`:"";

    return (
        <Fragment>
            <div className="gallery-pagination-area">
                <div style={{ height: "100%" }}>
                    <Typography style={{ whiteSpace: "nowrap", margin: "0.8rem", lineHeight: "1.5rem" }}>
                        Page size: {pageSize}
                    </Typography>
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <Select
                            variant="outlined"
                            id="demo-select-small"
                            value={pageSize}
                            onChange={handlePageSizeChange}
                            style={{ backgroundColor: "#FFFFFF" }}
                        >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={40}>40</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={200}>200</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div style={{ height: "100%", flex: "1" }}>
                    {/*<Typography style={{ margin: "0.8rem", lineHeight: "1.5rem" }}>*/}
                    {/*    {rowsMessage}*/}
                    {/*    {countMessage}*/}
                    {/*</Typography>*/}
                    <Typography style={{ margin: "0.8rem", lineHeight: "1.5rem" }}>
                        Page number: {page}
                    </Typography>
                    <Pagination
                        style={{ margin: "0.6rem", backgroundColor: "#FFFFFF", display: "flex", whiteSpace: "nowrap", flexWrap: "nowrap" }}
                        page={page}
                        count={pages}
                        variant="outlined"
                        shape="rounded"
                        onChange={selectPage}
                    />
                </div>
                <div style={{ height: "100%",  }}>
                    <Typography style={{ whiteSpace: "nowrap", margin: "0.8rem", lineHeight: "1.5rem" }}>
                        Total Results: {total}
                    </Typography>
                </div>
            </div>
        </Fragment>
    );
};

export default PaginationFooter;
